module.exports = __webpack_public_path__ + "img/logo_kikk.0b47ed01.png";